// extracted by mini-css-extract-plugin
export default {"container":"InputOTP_container__0C0E9","inputWrapper":"InputOTP_inputWrapper__ZLnIn","title":"InputOTP_title__AdXD2","errorWrapper":"InputOTP_errorWrapper__G05OV"};